export const I18n = {
	'en': {
		step_one: 'Step 1',
		step_two: 'Step 2',
		step_three: 'Step 3',
		create: 'Create a company',
		nextBtn: 'Next',
		prevBtn: 'Previous',
		stepOne: {
			nameRequired: 'Name is required',
			typeRequired: 'Type is required',
			countryRequired: 'Country is required',
			cityRequired: 'City is required',
			companyNamePlaceholder: 'Company name',
			companyName: 'Company name',
			dataInput: 'Please enter your data',
			innerUsage: 'Inner system usage',
			companyType: 'Company Type',
			chose: 'Choose',
			companyTraders: 'Traiders network',
			companyDev: 'Developer',
			companyOperator: 'Mobile operator',
			country: 'Country',
			inFieldCountry: 'Country registration',
			city: 'City',
			centralOffice: 'Central office location'
		},
		stepTwo: {
			managerRequired: 'Manager is required',
			phoneRequired: 'Phone number is required',
			skypeRequired: 'Skype is required',
			mailRequired: 'Email is requred',
			manager: 'Manager',
			innerUsage: 'Inner system usage',
			phone: 'Phone number',
			email: 'Email',
			skype: 'Skype'
		},
		stepThree: {
			thanks: 'Thanks for the registration!',
			start: 'Start working',
			registrationEnd: 'End of the registration',
			text: `You have successfully coped with the initial setup. Our manager will contact you soon and advise you in detail
			 on how to work in the system and tell you about all its capabilities. Meanwhile you can read 
			 the instructions that we have prepared for you.`,
			save: 'Save'
		}


	},
	'ru': {
		step_one: 'Шаг 1',
		step_two: 'Шаг 2',
		step_three: 'Шаг 3',
		create: 'Создание компании',
		nextBtn: 'Далее',
		prevBtn: 'Назад',
		stepOne: {
			nameRequired: 'Поле имя обязательно',
			typeRequired: 'Поле тип обязательно',
			countryRequired: 'Поле страна обязательно',
			cityRequired: 'Поле город обязательно',
			companyNamePlaceholder: 'Название компании',
			companyName: 'Название компании',
			dataInput: 'Введите ваши данные',
			innerUsage: 'Используется внутри системы',
			companyType: 'Тип компании',
			chose: 'Выбор',
			companyTraders: 'Торговая сеть',
			companyDev: 'Разработчик',
			companyOperator: 'Мобильный оператор',
			country: 'Страна',
			inFieldCountry: 'В рамках какой страны ведется деятельность',
			city: 'Город',
			centralOffice: 'Местонахождение цетрального офиса'
		},
		stepTwo: {
			managerRequired: 'Поле менеджер обязательно',
			phoneRequired: 'Поле телефон обязательно',
			skypeRequired: 'Поле skype обязательно',
			mailRequired: 'Поле email обязательно',
			manager: 'Руководящий менеджер',
			innerUsage: 'Используется внутри системы',
			phone: 'Контактный телефон',
			email: 'Email',
			skype: 'Skype'
		},
		stepThree: {
			thanks: 'Спасибо за регистрацию!',
			start: 'Начать работу',
			registrationEnd: 'Завершение регистрации',
			text: `Вы успешно справились с первичной настройкой. Наш менеджер скоро свяжеться с Вами и детально
				проконсультирует по работе в системе и расскажет о всех ее возможностях. А пока
				Вы можете ознакомиться с инструкциями, которые мы приготовили для Вас.`,
			save: 'Сохранить'
		}
	},
	'sk': {
		step_one: 'Krok 1',
		step_two: 'Krok 2',
		step_three: 'Krok 3',
		create: 'Založiť firmu',
		nextBtn: 'Ďalšie',
		prevBtn: 'predchádzajúca',
		stepOne: {
			nameRequired: 'Meno je povinné',
			typeRequired: 'Je požadovaný typ',
			countryRequired: 'Je potrebné krajiny',
			cityRequired: 'Je potrebné City',
			companyNamePlaceholder: 'Meno spoločnosti',
			companyName: 'Meno spoločnosti',
			dataInput: 'Prosím, zadajte svoje údaje',
			innerUsage: 'Vnútorné použitie systému',
			companyType: 'Typ spoločnosti',
			chose: 'Zvoliť',
			companyTraders: 'Traiders siete',
			companyDev: 'Vývojka',
			companyOperator: 'Mobilný operátor',
			country: 'Krajina',
			inFieldCountry: 'Registrácia krajiny',
			city: 'Veľkomesto',
			centralOffice: 'Centrálna poloha office'
		},
		stepTwo: {
			managerRequired: 'Je potrebné manažér',
			phoneRequired: 'Telefónne číslo je povinné',
			skypeRequired: 'Skype je vyžadované',
			mailRequired: 'E-mail je vyžadované',
			manager: 'Manažér',
			innerUsage: 'Vnútorné použitie systému',
			phone: 'Telefónne číslo',
			email: 'E-mail',
			skype: 'Skype'
		},
		stepThree: {
			thanks: 'Vďaka za registráciu!',
			start: 'Začať pracovať',
			registrationEnd: 'koniec registrácie',
			text: `Úspešne ste zvládli počiatočného nastavenia. Náš manažér vám ozveme a poradí v detaile
 					o tom, ako pracovať v systéme a informovať vás o všetkých svojich schopností. Medzitým
					si môžete prečítať pokyny, ktoré sme pre vás pripravili.`,
			save: 'Uložiť'
		}
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/createCompany/index.js